export enum MalaysianCitizenStatus {
    NotSet = 'NotSet',
    Yes = 'Yes',
    No = 'No',
}